import type { TimelineComponent } from "../../types";

/**
 * Timeline block — a vertical chronology (frise chronologique) with a rail,
 * one dot per milestone, the date as a blue pill and the event on a soft-blue
 * card. Replaces the flat two-column table look for historical pages while
 * keeping the exact site palette: rail/dots/dates in #0095DB, event cards in
 * #EDF7FC with #005CA9 text.
 */
export function TimelineRenderer({ component }: { component: TimelineComponent }) {
  const items = (component.content?.items ?? []).filter(
    (item) => (item?.date ?? "").trim().length > 0 || (item?.text ?? "").trim().length > 0,
  );
  if (items.length === 0) return null;

  return (
    <section className="timeline-block py-2">
      <ol className="relative ml-2 space-y-6 border-l-2 border-[#0095DB]/25 pl-7 md:ml-3 md:pl-9">
        {items.map((item, index) => (
          <li key={`${item.date}-${index}`} className="relative">
            <span
              aria-hidden="true"
              className="absolute -left-[38px] top-1 h-4 w-4 rounded-full border-[3px] border-white bg-[#0095DB] shadow-[0_0_0_2px_rgba(0,149,219,0.35)] md:-left-[46px]"
            />
            <div className="flex flex-col gap-2 md:flex-row md:items-start md:gap-4">
              <span className="inline-flex w-fit shrink-0 items-center rounded-full bg-[#0095DB] px-3.5 py-1 text-sm font-semibold leading-6 text-white md:min-w-[10.5rem] md:justify-center">
                {item.date}
              </span>
              <p className="flex-1 rounded-md bg-[#EDF7FC] px-4 py-2.5 text-base font-medium leading-6 text-[#005CA9] xl:text-lg">
                {item.text}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
